module.exports = __webpack_public_path__ + "static/media/logo_caliber.e1eafb75.svg";